import moment from 'moment';
import { message } from 'antd';
import { getToDay } from '@/utils/date';
import { isAreaData } from '@/services/area';
import {
  search_week,
  weekAggregate,
  search_month,
  monthAggregate,
  monthExport,
  weekExport,
} from '@/services/costTx';

let [startDate] = getToDay();

export default {
  namespace: 'directrateTx',
  state: {
    searchParams: {
      monthNumber: moment(startDate).subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss'),
      firstDepartureTime: moment(startDate).subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss'),
      transportLineType: ['长途', '区域', '区内', '长线', '短线', '支线', '短途'],
      businessType: ['干线', '网点线,支线'],
      filling: ['填仓货'],
      weekType: ['工作日', '周六', '周日'],
      directionType: 2,
    },
    pageWeek: 1,
    pageSizeWeek: 50,
    totalWeek: 0,
    pageMonth: 1,
    pageSizeMonth: 50,
    totalMonth: 0,
    weekDatas: [],
    monthDatas: [],

    onSearch: false,
    transportLineType: '',
    weekType: '',
    exportVisible: false,
    access: {
      isHead: false,
      isArea: false,
      isCenter: true,
      code: '',
    },
    lineMonthSelectType: 'day',
  },

  effects: {
    // 周值
    *search_week(_, { put, select }) {
      const directrateTx = yield select(({ directrateTx }) => directrateTx);
      const { access, searchParams } = directrateTx;

      const {
        departureCenter, // 出发组织
      } = searchParams;

      if (!access.isHead && !departureCenter) {
        message.warn('请选择出发站点/营运区');
        return;
      }
      const isDepartureArea = yield Promise.resolve(
        isAreaData(directrateTx?.searchParams?.departureCenter?.code),
      );
      const isArrivalArea = yield Promise.resolve(
        isAreaData(directrateTx?.searchParams?.arrivalCenter?.code),
      );
      const obj = handler(directrateTx, 'day', isDepartureArea, isArrivalArea);

      const [result, data] = yield Promise.all([search_week(obj), weekAggregate(obj)]);

      if (result?.code === 1) {
        let arr = (result?.data?.rows || []).map((item) => {
          const { arrival, departure, ratio } = item;
          return {
            direction: `${departure}-${arrival}`.replace(
              /分拨中心|经营本部|省区|营运区|管理区/g,
              '',
            ),
            ...mapRatioData(ratio),
          };
        });
        // arr.unshift(first);
        yield put({
          type: 'updateState',
          payload: {
            first: [],
          },
        });
        if (arr.length > 0) {
          let first = { direction: '合计' };
          if (data?.code === 1) {
            (data?.data || []).forEach((i) => {
              first[i.name] = i.ratio;
            });
            yield put({
              type: 'updateState',
              payload: {
                first,
              },
            });
          }
        }
        yield put({
          type: 'updateState',
          payload: {
            weekDatas: arr || [],
            totalWeek: result?.data?.total || 0,
          },
        });
      }
    },
    *getWeek(_, { call, put, select }) {
      let directrateTx = yield select(({ directrateTx }) => directrateTx);
      const { access, searchParams } = directrateTx;

      const {
        departureCenter, // 出发组织
      } = searchParams;

      if (!access.isHead && !departureCenter) {
        message.warn('请选择出发站点/营运区');
        return;
      }
      const isDepartureArea = yield Promise.resolve(
        isAreaData(directrateTx?.searchParams?.departureCenter?.code),
      );
      const isArrivalArea = yield Promise.resolve(
        isAreaData(directrateTx?.searchParams?.arrivalCenter?.code),
      );
      const obj = handler(directrateTx, 'day', isDepartureArea, isArrivalArea);

      const result = yield call(search_week, obj);

      if (result?.code === 1) {
        let arr = (result?.data?.rows || []).map((item) => {
          const { arrival, departure, ratio } = item;
          return {
            direction: `${departure}-${arrival}`.replace(
              /分拨中心|经营本部|省区|营运区|管理区/g,
              '',
            ),
            ...mapRatioData(ratio),
          };
        });

        yield put({
          type: 'updateState',
          payload: {
            weekDatas: arr || [],
            totalWeek: result?.data?.total || 0,
          },
        });
      }
    },
    *exportWeek(_, { call, put, select }) {
      let directrateTx = yield select(({ directrateTx }) => directrateTx);
      const { access, searchParams } = directrateTx;

      const {
        departureCenter, // 出发组织
      } = searchParams;

      if (!access.isHead && !departureCenter) {
        message.warn('请选择出发站点/营运区');
        return;
      }
      const isDepartureArea = yield Promise.resolve(
        isAreaData(directrateTx?.searchParams?.departureCenter?.code),
      );
      const isArrivalArea = yield Promise.resolve(
        isAreaData(directrateTx?.searchParams?.arrivalCenter?.code),
      );
      const obj = handler(directrateTx, 'day', isDepartureArea, isArrivalArea);

      const result = yield call(weekExport, obj);

      if (result?.code === 1) {
        message.success('导出成功');
        yield put({
          type: 'updateState',
          payload: {
            exportVisible: false,
          },
        });
      }
    },
    // 月
    *search_month(_, { put, select }) {
      let directrateTx = yield select(({ directrateTx }) => directrateTx);
      const { access, searchParams } = directrateTx;

      const {
        departureCenter, // 出发组织
      } = searchParams;

      if (!access.isHead && !departureCenter) {
        message.warn('请选择出发站点/营运区');
        return;
      }
      const isDepartureArea = yield Promise.resolve(
        isAreaData(directrateTx?.searchParams?.departureCenter?.code),
      );
      const isArrivalArea = yield Promise.resolve(
        isAreaData(directrateTx?.searchParams?.arrivalCenter?.code),
      );
      const obj = handler(directrateTx, 'month', isDepartureArea, isArrivalArea);

      const [result, data] = yield Promise.all([search_month(obj), monthAggregate(obj)]);

      if (result?.code === 1) {
        let arr = (result?.data?.rows || []).map((item) => {
          const { arrival, departure, ratio } = item;
          return {
            direction: `${departure}-${arrival}`.replace(
              /分拨中心|经营本部|省区|营运区|管理区/g,
              '',
            ),
            ...mapRatioData(ratio),
          };
        });
        // arr.unshift(second);
        yield put({
          type: 'updateState',
          payload: {
            second: [],
          },
        });
        if (arr.length > 0) {
          let second = { direction: '合计' };
          if (data?.code === 1) {
            (data?.data || []).forEach((i) => {
              second[i.name] = i.ratio;
            });
            yield put({
              type: 'updateState',
              payload: {
                second,
              },
            });
          }
        }

        yield put({
          type: 'updateState',
          payload: {
            monthDatas: arr || [],
            totalMonth: result?.data?.total || 0,
          },
        });
      }
    },
    *getMonth(_, { call, put, select }) {
      let directrateTx = yield select(({ directrateTx }) => directrateTx);
      const { access, searchParams } = directrateTx;

      const {
        departureCenter, // 出发组织
      } = searchParams;

      if (!access.isHead && !departureCenter) {
        message.warn('请选择出发站点/营运区');
        return;
      }
      const isDepartureArea = yield Promise.resolve(
        isAreaData(directrateTx?.searchParams?.departureCenter?.code),
      );
      const isArrivalArea = yield Promise.resolve(
        isAreaData(directrateTx?.searchParams?.arrivalCenter?.code),
      );
      const obj = handler(directrateTx, 'month', isDepartureArea, isArrivalArea);

      const result = yield call(search_month, obj);

      if (result?.code === 1) {
        let arr = (result?.data?.rows || []).map((item) => {
          const { arrival, departure, ratio } = item;
          return {
            direction: `${departure}-${arrival}`.replace(
              /分拨中心|经营本部|省区|营运区|管理区/g,
              '',
            ),
            ...mapRatioData(ratio),
          };
        });

        yield put({
          type: 'updateState',
          payload: {
            monthDatas: arr || [],
            totalMonth: result?.data?.total || 0,
          },
        });
      }
    },
    *exportMonth(_, { call, put, select }) {
      let directrateTx = yield select(({ directrateTx }) => directrateTx);
      const { access, searchParams } = directrateTx;

      const {
        departureCenter, // 出发组织
      } = searchParams;

      if (!access.isHead && !departureCenter) {
        message.warn('请选择出发站点/营运区');
        return;
      }
      const isDepartureArea = yield Promise.resolve(
        isAreaData(directrateTx?.searchParams?.departureCenter?.code),
      );
      const isArrivalArea = yield Promise.resolve(
        isAreaData(directrateTx?.searchParams?.arrivalCenter?.code),
      );
      const obj = handler(directrateTx, 'month', isDepartureArea, isArrivalArea);

      const result = yield call(monthExport, obj);

      if (result?.code === 1) {
        message.success('导出成功');
        yield put({
          type: 'updateState',
          payload: {
            exportVisible: false,
          },
        });
      }
    },
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
    updateSearchParams(state, { payload }) {
      return { ...state, searchParams: { ...state.searchParams, ...payload } };
    },
  },
};

const mapRatioData = (ratio) => {
  const inObj = {};
  (ratio || []).forEach((i) => {
    inObj[i.name] = i.ratio;
    if (i.ticketRatio !== undefined && i.ticketRatio !== null) {
      inObj[`${i.name}票均重`] = i.ticketRatio;
    }
  });
  return inObj;
};

const handler = (directrateTx, type, isDepartureArea, isArrivalArea) => {
  const { searchParams, pageWeek, pageSizeWeek, pageMonth, pageSizeMonth } = directrateTx;

  const {
    monthNumber,
    weekType,

    firstDepartureTime, // 日期
    departureCenter, // 出发组织
    arrivalCenter, // 到达组织
    transportLineType, // 线路类型
    businessType,
    filling, // 填仓货
    directionType, // 流向类型
  } = searchParams;

  let obj = {
    directionType,
    page: type === 'month' ? pageMonth : pageWeek,
    pageSize: type === 'month' ? pageSizeMonth : pageSizeWeek,
  };

  if (type === 'month') {
    if (monthNumber) {
      obj.monthNumber = moment(monthNumber).format('YYYY-MM');
    }
    if (weekType.length > 0) {
      obj.weekType = weekType.join(',');
    }
  } else {
    if (firstDepartureTime) {
      obj.firstDepartureTime = moment(firstDepartureTime).format('YYYY-MM-DD');
    }
  }
  if (departureCenter) {
    obj.departureLevel = isDepartureArea ? 1 : 2;
    obj.departureCode = departureCenter.code;
  }
  if (arrivalCenter) {
    obj.arrivalLevel = isArrivalArea ? 1 : 2;
    obj.arrivalCode = arrivalCenter.code;
  }
  // if (departureCenter) {
  //   obj.departureLevel = departureCenter.siteTypeCode === '900800' ? 1 : 2;
  //   obj.departureCode = departureCenter.code;
  // }
  // if (arrivalCenter) {
  //   obj.arrivalLevel = arrivalCenter.siteTypeCode === '900800' ? 1 : 2;
  //   obj.arrivalCode = arrivalCenter.code;
  // }
  if (filling.length === 1) {
    obj.filling = true;
  }

  if (transportLineType && transportLineType.length > 0) {
    obj.transportLineType = transportLineType.join(',');
  }
  if (businessType && businessType.length > 0) {
    obj.businessType = businessType.join(',');
  }
  return obj;
};
